export const ALWAYS_VISIBLE = "AlwaysVisible";
export const ALWAYS_HIDDEN = "AlwaysHidden";
export const HIDDEN_IF_SYSTEM_POPULATED = "HiddenIfSystemPopulated";

export const VisibilityOptions = [
    "AlwaysVisible",
    "AlwaysHidden",
    "HiddenIfSystemPopulated"
];